(() => {
  const initialize = (root) => {
    if (!root || root.dataset.atlasTabsReady === 'true') return;
    const buttons = [...root.querySelectorAll('[data-atlas-tab-button]')];
    const panels = [...root.querySelectorAll('[data-atlas-tab-panel]')];

    const activate = (name, focus = false) => {
      buttons.forEach((button) => {
        const active = button.dataset.atlasTabButton === name;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.atlasTabPanel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button.dataset.atlasTabButton));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        activate(buttons[next].dataset.atlasTabButton, true);
      });
    });

    root.dataset.atlasTabsReady = 'true';
    activate(buttons.find((button) => button.classList.contains('is-active'))?.dataset.atlasTabButton || 'expect');
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-atlas-product-tabs]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
